module.exports = __webpack_public_path__ + "img/enteringCode2.c86d98d7.jpg";